import Typography from '@mui/material/Typography';
import React from 'react';

import * as Styled from './progress-bar.style';
import { ProgressBarVariants } from './types';

export type ProgressBarProps = {
  total: number;
  completed: number;
  hidePercentage?: boolean;
  variant?: ProgressBarVariants;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  total,
  completed,
  hidePercentage,
  variant = ProgressBarVariants.Default,
}) => {
  const percentage = Math.min(
    100,
    Math.max(0, Math.floor((100 / total) * completed) || 0),
  );

  const typographyVariant =
    variant === ProgressBarVariants.Inverse ? 'caption' : 'subtitle2';

  return (
    <Styled.Container $variant={variant}>
      <Styled.Bar $percentage={percentage} $variant={variant} />

      {!hidePercentage && (
        <Typography variant={typographyVariant} component="span">
          {percentage}%
        </Typography>
      )}
    </Styled.Container>
  );
};
